import { NebulaFighterTheme } from './schemes/NebulaFighterTheme';
import { ClarkTheme } from './schemes/ClarkTheme';

export function themeCreator(theme) {
  return themeMap[theme];
}

const themeMap = {
  NebulaFighterTheme,
  ClarkTheme
};
